import PropTypes from 'prop-types';
import { filterLogicLogsCSS } from './styles/FilterLogicButton.styles';

export default function FilterLogicLogs({ errorMsg }) {
    return <div css={filterLogicLogsCSS}>{errorMsg}</div>;
}

FilterLogicLogs.propTypes = {
    errorMsg: PropTypes.string,
};
